function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "pfx67112__a"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 0 0.890196 0 0 0 1.000000 0"
})), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v21.574c16.399 0 29.695 3.485 29.695 7.785v43.97C29.695 77.63 16.4 83.616 0 83.616L.058 91H73V0",
  id: "pfx67112__b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.27 56.924c0 4.273 13.43 7.735 29.995 7.735 16.564 0 29.994-3.462 29.994-7.735l2.818-51.348L0 4.173l5.27 52.751z",
  id: "pfx67112__d"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(156 29)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-12.732 -31.28)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M48.732 103.278c6-41-26-55-25.754-77",
  stroke: "#EBEDE3",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(172 24.49 16.64)",
  filter: "url(#pfx67112__a)"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#E84A32",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(8.527 4.857)"
}, /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-108 5.08 4.235)",
  d: "M2.888 8.864L7.272 -0.394"
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-108 8.187 13.798)",
  d: "M9.914 18.619L6.459 8.977"
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-108 16.403 19.587)",
  d: "M21.112 21.613L11.694 17.561"
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-108 27.242 13.95)",
  d: "M31.353 10.891L23.13 17.01"
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-108 29.865 2.526)",
  d: "M30.517 -2.553L29.212 7.604"
})), /*#__PURE__*/React.createElement("path", {
  d: "M8.974 16.332L4 18.05"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.974 19.332L0.375 19.632"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.668 23.801L17.502 27.876"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.668 0.801L30.502 4.876"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.075 21L33.388 25.72"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.075 29L35.375 29.632"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.075 0L21.388 4.72"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.341 12.426L40.424 13.399"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.341 14.426L46.375 14.632"
})), /*#__PURE__*/React.createElement("circle", {
  fill: "#E84A32",
  cx: 26.875,
  cy: 10.132,
  r: 1
}))), /*#__PURE__*/React.createElement("path", {
  d: "M66 60c0 4.419-13.655 8-30.5 8S5 64.419 5 60c0-4.419 13.655-8 30.5-8S66 55.581 66 60",
  fill: "#544D44"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(36.3 30.5)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "pfx67112__c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#pfx67112__b"
})), /*#__PURE__*/React.createElement("path", {
  d: "M11.914 23.849c3.364-2.637 14.24 5.832 24.296 18.916 10.056 13.083 15.481 25.826 12.117 28.462-3.363 2.637-14.24-5.832-24.297-18.916C13.974 39.228 8.55 26.485 11.914 23.849",
  fill: "#544D44",
  mask: "url(#pfx67112__c)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.417 66.454l-6.09 4.773c3.365-2.637-2.06-15.38-12.116-28.462-10.056-13.083-20.934-21.553-24.297-18.917l6.09-4.772c3.363-2.637 14.241 5.832 24.297 18.916 10.056 13.082 15.48 25.825 12.116 28.462",
  fill: "#CAC5B8",
  mask: "url(#pfx67112__c)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(5 60)",
  fill: "#CAC5B8"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 44.542V12c0 4.372 13.655 7.915 30.5 7.915S61 16.372 61 12v32.542C61 48.914 47.345 55 30.5 55S0 48.914 0 44.542"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 8V0c0 4.419 13.655 8 30.5 8S61 4.419 61 0v8c0 4.419-13.655 8-30.5 8S0 12.419 0 8"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 3.327)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "pfx67112__e",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#pfx67112__d"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#EBEDE3",
  mask: "url(#pfx67112__e)",
  d: "M39.3554534 55.3992576L23.1701826 55.3992576 23.1701826 45.7705794 46.4305911 45.7705794 46.4305911 55.3992576z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.58 35.392l-1.271 8.454h-6.371l.459-9.175a3.453 3.453 0 0 1 .6-1.764 3.54 3.54 0 0 1 2.94-1.578h.138c1.189 0 2.296.591 2.952 1.576.491.73.688 1.619.552 2.487",
  fill: "#CAC5B8",
  mask: "url(#pfx67112__e)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.046 34.898c-.028-1.943 1.535-3.54 3.492-3.57h.358a3.54 3.54 0 0 1 2.945 1.579c.425.624.634 1.372.595 2.124l-.443 8.814h-6.47l-.473-8.894-.004-.053z",
  fill: "#8D8173",
  mask: "url(#pfx67112__e)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.443 32.905a3.55 3.55 0 0 1 2.95-1.576h.16c1.93.01 3.5 1.544 3.547 3.46l.005.106v.037l.474 8.913h-6.363l-1.357-8.867a3.458 3.458 0 0 1 .59-2.071l-.006-.002z",
  fill: "#CAC5B8",
  mask: "url(#pfx67112__e)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.016 67.916L12.79 35.643c-.434-1.904.769-3.796 2.686-4.227a3.57 3.57 0 0 1 3.748 1.49c.311.455.51.975.58 1.52l.115.738c.007.126.014.252.034.403l1.278 8.278v13.48h2.083l.207 1.347 1.428 9.244h-3.933z",
  fill: "#8D8173",
  mask: "url(#pfx67112__e)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CAC5B8",
  mask: "url(#pfx67112__e)",
  d: "M26.9098217 67.9158293L25.9164437 61.4446476 25.2839693 57.3251708 30.3026718 57.3251708 30.8708268 67.9158293z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8D8173",
  mask: "url(#pfx67112__e)",
  d: "M36.7851774 67.9158293L32.8116657 67.9158293 32.2452973 57.3251708 37.319386 57.3251708z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CAC5B8",
  mask: "url(#pfx67112__e)",
  d: "M42.6875574 67.9158293L38.7265523 67.9158293 39.2589742 57.3251708 44.28125 57.3251708z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.646 35.733l-8.065 32.184H44.65l1.593-10.593h2.127V43.846l1.338-9.533a3.49 3.49 0 0 1 .568-1.408 3.552 3.552 0 0 1 4.902-.985 3.501 3.501 0 0 1 1.467 3.811l.002.002z",
  fill: "#8D8173",
  mask: "url(#pfx67112__e)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.017 27.822a1.736 1.736 0 0 1 1.572-.14.971.971 0 0 0 1.299-.964c0-.023-.015-.095-.018-.122a1.93 1.93 0 0 1 1.436-1.85.96.96 0 0 0 .645-1.286 1.875 1.875 0 0 1-.026-1.365 1.96 1.96 0 0 1 1.193-1.17 1.87 1.87 0 0 1 1.576.155.975.975 0 0 0 1.297-.323 1.915 1.915 0 0 1 1.503-.883.968.968 0 0 0 .9-1.025.966.966 0 0 0-.254-.586 1.897 1.897 0 0 1-.484-1.652 1.951 1.951 0 0 1 1.462-1.514 1.853 1.853 0 0 1 1.391.204.973.973 0 0 0 1.298-.322 1.94 1.94 0 0 1 2.663-.607c.567.354.908.97.908 1.631 0 .533.432.964.968.964a.965.965 0 0 0 .969-.964c0-1.06.865-1.92 1.931-1.92a1.932 1.932 0 0 1 1.819 1.264c.116.314.39.545.72.61a.965.965 0 0 0 .9-.289 1.944 1.944 0 0 1 1.583-.616 2.022 2.022 0 0 1 1.62 1.24c.194.421.203.904.026 1.332a.96.96 0 0 0 .579 1.233.956.956 0 0 0 .332.06c.043 0 .14-.015.182-.02 1.07 0 1.939.862 1.939 1.925 0 .533.434.964.97.964 1.06 0 1.922.845 1.939 1.897 0 .025-.017.128-.018.151a.965.965 0 0 0 .91 1.019.97.97 0 0 0 .389-.055c.21-.08.432-.122.655-.124a1.93 1.93 0 0 1 1.939 1.897c0 .025-.015.126-.016.15a.965.965 0 0 0 1.299.963 1.749 1.749 0 0 1 1.575.142c.522.282.888.78.997 1.361.065.416-.01.84-.216 1.209l-.023-.014c-.2-.137-.41-.263-.627-.373l-.16-.076a5.08 5.08 0 0 0-.637-.256c-.018-.005-.036-.014-.055-.021a5.527 5.527 0 0 0-.722-.167l-.175-.027a5.372 5.372 0 0 0-.754-.058 5.479 5.479 0 0 0-4.556 2.433l-.013.02-.01-.02a5.482 5.482 0 0 0-4.562-2.433h-.14a5.477 5.477 0 0 0-4.518 2.389 5.483 5.483 0 0 0-4.52-2.39h-.309c-1.808 0-3.5.89-4.518 2.376a5.477 5.477 0 0 0-4.517-2.375h-.159a5.485 5.485 0 0 0-4.561 2.43 5.462 5.462 0 0 0-5.559-2.334c-.098.016-.187.04-.28.062-.23.053-.457.12-.677.204-.091.034-.18.064-.27.103a5.4 5.4 0 0 0-.788.419c-.02.012-.041.021-.06.033h-.01a1.883 1.883 0 0 1-.175-1.137 1.96 1.96 0 0 1 1.003-1.362",
  fill: "#EBEDE3",
  mask: "url(#pfx67112__e)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.841 19.775l-.394-.55-.647.09a1.5 1.5 0 0 1-.199.02 1.932 1.932 0 0 1-1.938-1.926A1.93 1.93 0 0 1 9.6 15.483c.08.004.161.015.24.027l.657.084.317-.577a1.936 1.936 0 0 1 2.61-.792 1.92 1.92 0 0 1 1.022 1.699 1.875 1.875 0 0 1-.272.963l-.284.481.284.481c.177.291.27.623.272.964a1.931 1.931 0 0 1-1.939 1.924 1.92 1.92 0 0 1-1.667-.962m20-14l-.394-.55-.647.09a1.5 1.5 0 0 1-.199.02 1.932 1.932 0 0 1-1.938-1.926A1.93 1.93 0 0 1 29.6 1.483c.08.004.161.015.24.027l.657.084.317-.577a1.936 1.936 0 0 1 2.61-.792 1.92 1.92 0 0 1 1.022 1.699 1.875 1.875 0 0 1-.272.963l-.284.481.284.481c.177.291.27.623.272.964a1.931 1.931 0 0 1-1.939 1.924 1.92 1.92 0 0 1-1.667-.962m30.826 14c.176.291.27.623.271.962A1.932 1.932 0 0 1 60 22.663a1.92 1.92 0 0 1-1.667-.962l-.395-.55-.647.09c-.066.013-.132.02-.198.021a1.932 1.932 0 0 1-1.939-1.925c0-1.063.867-1.926 1.939-1.926.08.005.16.014.24.028l.657.084.316-.579a1.935 1.935 0 0 1 2.61-.79c.63.334 1.024.985 1.022 1.695a1.875 1.875 0 0 1-.271.964l-.284.481.284.481z",
  fill: "#EBEDE3"
})));

function SvgQ5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 382,
    height: 146,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ5);
export default __webpack_public_path__ + "static/media/q5.a558580e.svg";
export { ForwardRef as ReactComponent };